<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import SalesReceiptDraftDocument from '../components/SalesReceiptDraftDocument.vue';
import SalesReceiptDraftFooter from '../components/SalesReceiptDraftFooter.vue';
import { useSalesReceiptDraft } from '../composables/useSalesReceiptDraft';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const id = computed(() => route.params.salesTransactionId);
const draft = useSalesReceiptDraft({ id, t, notify: useAlert });

const backToRegistration = () =>
  router.push({
    name: 'operacao_imobiliaria_vendas_cadastro',
    params: { accountId: route.params.accountId, salesTransactionId: id.value },
  });

watch(
  () => draft.unavailable.value,
  unavailable => {
    if (unavailable) backToRegistration();
  }
);
</script>

<template>
  <div class="min-h-full bg-[#F6F8F9]" data-test="sales-receipt-draft-page">
    <LaisHeader
      :title="t('SALES.RECEIPT_DRAFT.TITLE')"
      :subtitle="t('SALES.RECEIPT_DRAFT.HEADER_SUBTITLE')"
      :breadcrumb="[
        { label: t('SALES.TITLE') },
        { label: t('SALES.RECEIPT_DRAFT.TITLE') },
      ]"
      :back-label="t('SALES.RECEIPT_DRAFT.BACK')"
      show-back
      @back="backToRegistration"
    />

    <main class="mx-auto w-full px-4 py-5 sm:px-6 lg:px-10 lg:py-10">
      <div
        v-if="draft.loading.value"
        class="rounded-[10px] border border-lais-border-soft bg-white p-10 text-center text-sm text-lais-text-muted"
      >
        {{ t('SALES.RECEIPT_DRAFT.LOADING') }}
      </div>
      <div
        v-else-if="draft.error.value && !draft.unavailable.value"
        class="rounded-[10px] border border-lais-border-soft bg-white p-10 text-center text-sm text-lais-text-muted"
      >
        {{ draft.error.value }}
      </div>
      <SalesReceiptDraftDocument
        v-else-if="draft.draft.value"
        :document="draft.draft.value.document"
      />
    </main>

    <SalesReceiptDraftFooter
      v-if="draft.draft.value"
      v-model:accepted="draft.accepted.value"
      :downloading="draft.downloading.value"
      :last-download="draft.lastDownload.value"
      @download="draft.download"
    />
  </div>
</template>
